export default __webpack_public_path__ + "static/proxima-nova-500-i-40e9764ca0b9c9298e26084607235a9a.woff";